import axios, { post } from "axios"

import { devMode } from "./base"

const baseDomain = `https://accounts${devMode ? "-dev" : ""}.mioto.vn`
const baseDomainProfile = `https://m-profile${devMode ? "-dev" : ""}.mioto.vn`

const commonDomain = `https://m-b2b${devMode ? "-dev" : ""}.mioto.vn`


export function getLoggedProfile() {
	return axios({
			withCredentials: true,
			method: "GET",
			url: `${baseDomain}/mapi/profile/get`
	})
}

export function getProfile(userId, vw) {
	var pVw = "";
	if (vw) {
			pVw = `&vw=${vw}`
	}
	return axios({
			method: "GET",
			withCredentials: true,
			url: `${baseDomainProfile}/profile/detail?userId=${userId}${pVw}`
	})
}

export function logout() {
	return axios({
			method: "POST",
			withCredentials: true,
			url: `${baseDomain}/mapi/logout`
	})
}

export function getListF2OfUser(pos, count, filter) {
	const mCount = count > 0 ? `&count=${count}` : '';
	const time = filter.time ? `&time=${filter.time}` : '';
	const convertDate = filter.timeInSeconds && filter.timeInSeconds.valueOf() / 1000;
	const timeInSeconds = filter.timeInSeconds ? `&timeInSeconds=${convertDate}` : '';


	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/f2/list?pos=${pos}${mCount}${time}${timeInSeconds}`
	})
}

export function getF2ListOrderDetail(f2UserId, pos, count, filter) {

	const time = filter.time ? `&time=${filter.time}` : '';
	const convertDate = filter.timeInSeconds.valueOf() / 1000;
	const timeInSeconds = filter.timeInSeconds ? `&timeInSeconds=${convertDate}` : '';

	return axios({
		withCredentials: true,
		method: "GET",
		url: `${commonDomain}/f2/detail?f2UserId=${f2UserId}&pos=${pos}&count=${count}${time}${timeInSeconds}`
	})
}



// WEBPACK FOOTER //
// ./src/model/profile.js